module.exports = __webpack_public_path__ + "img/956-e3f984.png";